import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './LeadGenButton.css';
import LeadGenModal from '../LeadGenModal/LeadGenModal';
import { dispatchOverlayLoad } from '../ModalCTA/utils';

const LeadGenButton = () => {
    const popupID = 'lead-gen-form';

    const [openModal, setOpenModal] = useState(false);

    const handleOnClick = (stringID) => {
        setOpenModal(true);
        dispatchOverlayLoad(stringID);
    };

    return (
        <React.Fragment>
            <div>
                <button
                    id="insights-lead-open-form"
                    className="text-button"
                    onClick={() => handleOnClick('Lead Generation: Input')}
                    aria-haspopup="dialog"
                    aria-controls={popupID}
                >
                    Subscribe Now
                </button>
            </div>
            <style jsx>{styles}</style>
            {openModal &&
                ReactDOM.createPortal(
                    <LeadGenModal
                        open={openModal}
                        onClose={() => setOpenModal(false)}
                        popupID={popupID}
                    />,
                    document.body
                )}
        </React.Fragment>
    );
};

export default LeadGenButton;



// WEBPACK FOOTER //
// ./src/components/LeadGenButton/LeadGenButton.js